import * as React from 'react';

import styles from './Sidebar.css';
import { VillageAboutBuilder } from './about_builder';
import { VillagePrices } from './prices';
import { IVillageSchema, MODERATION_STATUS_TYPES } from '../../types';

export interface ISidebarProps {
  village: IVillageSchema;
  isCroppedCard: boolean;
}

export const Sidebar = (props: ISidebarProps) => {
  const { village, isCroppedCard } = props;
  const { builder, priceMax, priceMin } = village;
  const renderAboutBuilder = builder?.moderationStatus === MODERATION_STATUS_TYPES.Published;

  if (isCroppedCard && !renderAboutBuilder) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {!isCroppedCard && <VillagePrices priceMax={priceMax} priceMin={priceMin} />}
      {renderAboutBuilder && <VillageAboutBuilder village={village} />}
      <div />
    </div>
  );
};
